import React, { useRef, useState } from 'react';
import './Contact.css';
import emailjs from 'emailjs-com';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Contact = () => {
  const form = useRef();
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

  const handleCloseSnackbar = () => {
    setIsSnackbarOpen(false);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_33nxfr9', 'template_rmw5ze8', form.current, 'avSci4xg5DPMkk_LJ')
      .then((result) => {
        console.log(result.text);
        form.current.reset();
        setIsSnackbarOpen(true);
      })
      .catch((error) => {
        console.log(error.text);
      });
  };

  return (
    <section id="contacts">
      <div className="contact__container">
        <h1>Get In Touch</h1>
        <div className="contact__card-1">
        <div class="contact_circle single_contct_circle" style={{ backgroundImage: 'url("/Assets/mail-pic.png")' }}>
            <span>Contact</span>
          </div>
          <div className="contact__card-1-inner">
            <div className="form__container">
              <form ref={form} onSubmit={sendEmail}>
                <label>Name</label>
                <input type="text" name="name" required/>
                <label>Email</label>
                <input type="email" name="email" />
                <label>Message</label>
                <textarea name="message" required/>
                <button type="submit">Send</button>
              </form>
            </div>
          
          </div>
        </div>
      </div>

      {/* Success Snackbar */}
      <Snackbar
        open={isSnackbarOpen}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleCloseSnackbar}
          severity="success"
          style={{ backgroundColor: '#1abc9c' }}
        >
          Message sent successfully!
        </MuiAlert>
      </Snackbar>
    </section>
  );
};

export default Contact;
